// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"f65348e7","129":"f65348e7","660":"f65348e7","670":"f65348e7","688":"a220faa8","947":"be77114e"}[chunkId] + ".chunk.css";
};